/**
 * Runtime configuration, read from Vite env at build time.
 *
 * Only `VITE_`-prefixed values reach the browser, and Vite inlines them — there
 * is no runtime lookup, so these are baked into the bundle and cannot be fixed
 * after the fact. Only `VITE_`-prefixed values reach the browser. Nothing secret
 * belongs here.
 *
 * The values themselves are committed, one file per mode, at the repo root:
 *
 *   .env.development   dev servers  -> the deployed Cloudflare Pages domains
 *   .env.production    builds       -> the canonical milliswift.com domains
 *
 * Both are shared by all four apps (packages/config/vite.js points envDir at the
 * repo root), so a cross-app URL cannot drift between them.
 *
 * There are deliberately NO fallback values here. A default like
 * `http://localhost:3010` looks harmless and is the reason every production
 * build so far shipped a site whose API calls and cross-app links pointed at the
 * visitor's own machine: no .env file existed, so every lookup silently took the
 * fallback, and nothing complained. A missing value is a build mistake, so it
 * fails here instead — loudly, and with the file to fix.
 */

function required(key: keyof ImportMetaEnv): string {
  const value = import.meta.env[key]
  if (typeof value !== 'string' || value.length === 0) {
    throw new Error(
      `[milliswift] ${key} is not set.\n` +
        `  It is defined for every mode at the repo root:\n` +
        `    .env.development  (npm run dev:*)  -> Cloudflare Pages domains\n` +
        `    .env.production   (npm run build)  -> canonical milliswift.com\n` +
        `  For a machine-specific override, copy .env.example to .env.local.`,
    )
  }
  return value
}

export const API_URL = required('VITE_API_URL')

/**
 * Serve the not-yet-implemented console endpoints from bundled fixtures.
 * Defaults on in dev so the pages are usable; always off in production builds,
 * where it would otherwise mask a missing backend.
 */
export const USE_MOCKS =
  import.meta.env.DEV && import.meta.env.VITE_USE_MOCKS !== 'false'

export const APP_URLS = {
  landing: required('VITE_LANDING_URL'),
  accounts: required('VITE_ACCOUNTS_URL'),
  myaccount: required('VITE_MYACCOUNT_URL'),
  platform: required('VITE_PLATFORM_URL'),
} as const

/** Header the platform requires on state-changing browser requests (CSRF). */
export const CSRF_HEADER = 'X-Milliswift-Request'
